<template>
  <v-container grid-list-md>
    <v-layout column fill-height class="empty-list">
      <v-btn class="empty-list-btn white--text" @click="onClickButton">
        <img src="static/icons/add_white.png" width="24" />
        {{ message }}
      </v-btn>
      <v-btn
        v-if="this.import == true"
        class="empty-list-btn white--text"
        @click="onClickImportButton"
      >
        <img src="static/icons/unarchive_white.png" width="24" />
        {{ $t('message.import.label') }}
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    message: String,
    import: Boolean
  },
  methods: {
    onClickButton() {
      this.$emit('clicked', 'true')
    },
    onClickImportButton() {
      this.$emit('importClicked', 'true')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/util/EmptyList.vue